export default __webpack_public_path__ + "static/media/caloocan-3.a614cb96.jpg";